let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6M0bz")).then(() => parcelRequire('js4PU'));